  <div class="nav" #el>
    <div class="navbar">
      <a class="brand" routerLink="/">
        <img src="assets/images/logo.svg" alt=""/>
      </a>
      <div class="links nav-items">
        <a routerLink="/" fragment="services">Services</a>
        <a routerLink="/case-studies">Our work</a>
        <a routerLink="/tech-stack">Our tech stack</a>
        <a routerLink="/team">Team</a>
        <a routerLink="/" fragment="contactus">Contact us</a>
      </div>
      <div class="menu" (click)="onMenu()">
        <input type="checkbox" hidden id="hamburger"/>
        <label for="hamburger" [hidden]="isOpen">
          <mat-icon>menu</mat-icon>
        </label>
        <label for="hamburger" [hidden]="!isOpen">
          <mat-icon>close</mat-icon>
        </label>
      </div>
      <div class="dropdown" id="dropdown" [class.show]="isOpen">
        <a routerLink="/" fragment="services">Services</a>
        <a routerLink="/case-studies">Our work</a>
        <a routerLink="/tech-stack">Our tech stack</a>
        <a routerLink="/team">Team</a>
        <a routerLink="/" fragment="contactus">Contact us</a>
      </div>
    </div>
  </div>
